import { Component, OnInit, AfterViewInit, ViewChild, Input, OnChanges, SimpleChanges } from '@angular/core';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { NxiContextUtils } from '@pershing/nxi-common';
import { DomainContext, IContextService, PershingTranslationService } from '@pershing/pershing-core';
import { Subscription } from 'rxjs';
@Component({
    selector: 'loanadvance-summary',
    templateUrl: './loanadvance-summary.component.html'
})
export class LoanAdvanceSummaryComponent implements OnInit, AfterViewInit, OnChanges {

    @Input() loanAdvanceSummary: any;
    localLoanData: any;
    collelateralData: any;
    displayedCollateralAccColumns = ['collateralaccountnumber', 'clientname', 'accountworth', 'registration'];
    dataSource: MatTableDataSource<Element>;
    collateralaDataSource: MatTableDataSource<Element>;
    @ViewChild('MatPaginator', { static: false }) paginator: MatPaginator;
    @ViewChild('sort', { static: false }) sort: MatSort;
    expandedElement: any;
    inputValue: string = '';
    domain: string = '';
    subs: Subscription;
    subs1: Subscription;
    acctRef: string;
    data: any;
    localLoanSummaryData: any;
    lowValue: number = 0;
    highValue: number = 20;
    collelateralDataList: any;
    creditLimit: boolean = true;
    outstadingbal: boolean = true;
    availablecredit: boolean = true;
    benchmark: boolean = true;
    rate: boolean = true;
    ytdinterest: boolean = true;
    mtdinterestaccured: boolean = true;
    payofamount: boolean = true;
    perdiem: boolean = true;

    constructor(
        private translationService: PershingTranslationService,
        private contextService: IContextService,
    ) {
        this.dataSource = new MatTableDataSource();
        this.collateralaDataSource = new MatTableDataSource();
    }

    ngOnInit() {
        this.subs = this.contextService.selectedDomainContext$.subscribe((domainContext: DomainContext<any>) => {
            let contextValue = NxiContextUtils.getContextFromDomainValue(domainContext);
            this.inputValue = contextValue.inputValue;
            this.acctRef = contextValue.hashValue;
        });
        this.translationService.addTranslationFolder('@pershing/nxi-ng-balances', 'node_modules/@pershing/nxi-ng-balances/lib');
        this.localLoanSummaryData = this.loanAdvanceSummary;
        this.dataSource = this.loanAdvanceSummary.noofCollateralAccount_RepeatingBlock;
    }
    ngAfterViewInit(): void {
        this.dataSource.sort = this.sort;
        this.dataSource.paginator = this.paginator;
    }
    ngOnChanges() {
        this.localLoanSummaryData = this.loanAdvanceSummary;
        this.dataSource = this.loanAdvanceSummary.noofCollateralAccount_RepeatingBlock;
    }
    goToBalances(acctNumber: any) {
        document.dispatchEvent(new CustomEvent('portal.gotoview', {
            detail: {
                'gotoPage': '/nxi/portfolio/balances',
                'gotoParams': {'nplFlag' : false},
                'context': { 'domain': 'account', 'value': acctNumber }
            }
        }));
    }
    public getPaginatorData(event: PageEvent): PageEvent {
        this.lowValue = event.pageIndex * event.pageSize;
        this.highValue = this.lowValue + event.pageSize;
        return event;
    }
}
